var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseLightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "share") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE\\u4E0Eicon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u89C4\\u8303\\u6C47\\u603B",
    transform: "translate(-53.000000, -596.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "share",
    transform: "translate(53.000000, 596.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "share-(style)",
    stroke: "#E6E8EC",
    strokeWidth: 2,
    fillRule: "nonzero",
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons/Close/Line",
    transform: "translate(13.000000, 13.000000)",
    fill: "#23262F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.292893596,0.292893596 C0.683418292,-0.0976309988 1.31658242,-0.0976309988 1.70711311,0.292893596 L7.00001254,5.58580002 L12.292922,0.292893596 C12.6834227,-0.0976311988 13.3166238,-0.0976311988 13.7071245,0.292893596 C14.0976252,0.683418292 14.0976252,1.31658242 13.7071245,1.70711311 L8.41422506,7.00001254 L13.7071245,12.292922 C14.0976252,12.6834227 14.0976252,13.3166238 13.7071245,13.7071245 C13.3166238,14.0976252 12.6834227,14.0976252 12.292922,13.7071245 L7.00001254,8.41422506 L1.70711311,13.7071245 C1.31658242,14.0976252 0.683419292,14.0976252 0.292893596,13.7071245 C-0.0976309988,13.3166238 -0.0976309988,12.6834227 0.292893596,12.292922 L5.58580002,7.00001254 L0.292893596,1.70711311 C-0.0976311988,1.31658242 -0.0976311988,0.683419292 0.292893596,0.292893596 Z",
    id: "Shape"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLightIcon);
export default __webpack_public_path__ + "static/media/close-light-icon.16ff6cc12bfff40a4e4334749892b801.svg";
export { ForwardRef as ReactComponent };